import type { WeatherState } from '@/core/types';
import { baseIntensity, blendIntensity, clamp01, type WeatherIntensity } from './intensity';

/**
 * Follows `weather:change` emissions ({ state, t }) and yields the effect intensity to drive the
 * layers. A redirect mid-transition blends from the *current* intensity, so nothing jumps.
 * Pure and deterministic (unit-tested).
 */
export class WeatherTrack {
  private fromI: WeatherIntensity;
  private _to: WeatherState;
  private _t = 1;
  constructor(initial: WeatherState) { this._to = initial; this.fromI = baseIntensity(initial); }
  get to(): WeatherState { return this._to; }
  get t(): number { return this._t; }
  get settled(): boolean { return this._t >= 1; }
  apply(e: { state: WeatherState; t: number }): void {
    const t = clamp01(e.t);
    if (e.state !== this._to) { this.fromI = this.intensity(); this._to = e.state; this._t = t; }
    else this._t = t; // same target: fromI is already base(to) when settled, so a restart is visually a no-op
    if (this._t >= 1) this.fromI = baseIntensity(this._to);
  }
  intensity(): WeatherIntensity { return this._t >= 1 ? baseIntensity(this._to) : blendIntensity(this.fromI, baseIntensity(this._to), this._t); }
}
